export const shippingMethodVisibility = {
  public: 'public',
  internal: 'internal',
}
